import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageItems,
  PageItem,
} from '../pages/items';

const RouteItems = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageItems />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageItem />
      </Route>
    </Switch>
  );
};

export default RouteItems;
